export default __webpack_public_path__ + "static/media/Camp-hub-Cover.82af0f83.png";